import React from 'react';
import { Typography } from '@material-ui/core';
import useStyles from './ImageDropzoneText.styles';
import { useTranslation } from 'react-i18next';
import tPaths from '../../../../utils/tPaths';

interface IProps {
  isDragActive: boolean;
}

const ImageDropzoneText: React.FC<IProps> = ({ isDragActive }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h6" className={classes.title}>
        {isDragActive ? t(tPaths.dropzone.dropHere) : t(tPaths.dropzone.uploadImage)}
      </Typography>
      <Typography variant="subtitle2" className={classes.description}>
        Max file size: 1MB - JPEG, JPG, PNG.
      </Typography>
    </>
  );
};

export default ImageDropzoneText;
